enum MODULE_TYPES {
  OWNER = "owner",
  CONSULTANT = "consultant",
  MANAGER = "manager",
  ADMIN = "admin",
  CASH_MANAGEMENT = "cashManagement"
}

export default MODULE_TYPES
